import { getUserPlatform } from 'modules/employees/add-edit-employee-modal/helpers';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { ComponentType } from 'react';

interface MobileRedirectWrapperProps {
  Component: ComponentType;
  redirectPath: string;
}

const MobileRedirectWrapper = ({ Component, redirectPath }: MobileRedirectWrapperProps) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const platform = getUserPlatform();
  const isMobile = platform === 'Android' || platform === 'iOS';

  if (searchParams.has('skipMobile') || !isMobile) {
    return <Component />;
  }

  return <Navigate to={redirectPath} state={{ from: location.pathname }} />;
};

export default MobileRedirectWrapper;
